//
//  envelope.ts
//  TrajeXY Signet Server
//
//  Copyright © 2026 TrajeXY. All rights reserved.
//
//  Created: September 21, 2026
//  Author: Bob Keathley
//
//  Response envelope types mirrored from the API spec. parseEnvelope turns any
//  unknown JSON into a success or error envelope; drift gives bad_envelope.
//  The UI reads this contract and never changes it.
//
// The response envelope, mirrored from docs/api/SIGNET_API_SPECIFICATION.md.
// `ui` reads the contract; it never changes it. Any shape drift fails here first.
export type Ok<T> = { success: true; data: T }
export type Err = { success: false; error: { code: string; message: string; details?: unknown } }
export type Envelope<T> = Ok<T> | Err

export function isOk<T>(e: Envelope<T>): e is Ok<T> {
  return e.success === true
}

export function parseEnvelope<T>(raw: unknown): Envelope<T> {
  if (typeof raw !== 'object' || raw === null || !('success' in raw)) {
    return { success: false, error: { code: 'bad_envelope', message: 'response was not a Signet envelope' } }
  }
  const r = raw as Record<string, unknown>
  if (r.success === true && 'data' in r) return { success: true, data: r.data as T }
  if (r.success === false && typeof r.error === 'object' && r.error !== null) return r as Err
  return { success: false, error: { code: 'bad_envelope', message: 'envelope had an unexpected shape' } }
}
